import request from "@/util/http";
import qs from "qs";

// 通知列表查询
export const getNoticeList = params =>
  request({
    url: "/admin/notice/page",
    method: "get",
    params,
  });

// 通知单个删除
export const handleNoticeDelete = id =>
  request({
    url: `/admin/notice/delete/${id}`,
    method: "delete",
  });
// 通知信息
export const getNoticeInfo = params =>
  request({
    url: `/admin/notice/get`,
    method: "get",
    params,
  });

// 通知信息已读
export const setNoticeRead = params =>
  request({
    url: `/admin/home/setNoticeRead`,
    method: "post",
    params,
  });

// 保存通知
export const addNoticeSave = data =>
  request({
    headers: {
      "Content-Type": "application/json",
    },
    url: "/admin/notice/save",
    method: "post",
    data: JSON.stringify(data),
  });

// 全部已读
export const allRead = data =>
  request({
    url: "/admin/notice/allRead",
    method: "post",
    data: qs.stringify(data),
  });
